import axios from 'axios';
import constantes from "../constantes";
import store from "../store";
import moment from "moment";

const PREFIJO="/api/Ngcn/";
const PREFIJO2="/api/PgNgcn/";

export default {
    busquedaId(){
        const dto ={
            id:store.getters.getCotizacion.ndt5,
        };
        return axios.post(`${PREFIJO}VmIdDNgc`,dto).then(r=>r.data).then(response=>{
            store.commit('setCotizacion',response);
        });
    },
    validacionDecicionDeCompra(){
        const dto ={
            id:store.getters.getCotizacion.ndt5,
        };
        return axios.post(`${PREFIJO}VmUpDcs`,dto);
    },
    listaPorTipo(tipoPago){
        const dto = {
            id:store.getters.getUsuario.ndt1,//username
            ndt1:constantes.Constantes.enumeraciones.campana.online,
            ndt2:tipoPago,
        };
        return axios.post(`${PREFIJO}VmSlDcs`,dto);
    },
    listarPagosRealizados(){
        const dto = {
            ndt1:store.getters.getCotizacion.ndt5,
        };
        return axios.post(`${PREFIJO2}VmLsPgNgc`,dto);
    },
    nuevoPago(formulario,tipo){
        const dto = {
            dt1:formulario.archivo.base64,
            dt2:formulario.cuenta,
            dt3:formulario.beneficiario,
            //dt5:formulario, id transaccional
            dt6:formulario.comprobante,
            dt7:formulario.email,
            dt8:tipo.dto,
            dt20:store.getters.getUsuario.dt1,
            ddt1:moment(formulario.fecha,"DD/MM/YYYY").toISOString(),
            ndt1:formulario.banco.id,
            ndt2:store.getters.getCotizacion.ndt5,
            ndt5:formulario.monto,
            ndt6:store.getters.getCotizacion.ndt3,
            ndt7:store.getters.getCotizacion.ndt6,
            dt14:'',
        };
        return axios.post(`${PREFIJO2}VmCrPgNgc`,dto);
    },
    actualizaACuota(formulario){
        const dto = {
            id:store.getters.getCotizacion.ndt5,
            ndt1:2,
            ndt2:formulario.valor,
            ndt3:formulario.respuesta,
            ndt4:formulario.plazo.ndt1,
            ndt5:formulario.banco.id,
        };
        return axios.post(`${PREFIJO}VmUpNgc`,dto);
    },
    envioEmailDatosAgencia(){
        const dto = {
            ndt1:store.getters.getCotizacion.ndt6,
            ndt2:store.getters.getUsuario.ndt1,
            ndt3:store.getters.getUsuario.id,
            dt1:store.getters.getUsuario.dt96,
            dt2:store.getters.getUsuario.dt2,
        };
        return axios.post(`${PREFIJO2}VmNvDts`,dto);
    }
}
